'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShadowingIdentifiers = getShadowingIdentifiers;
exports.containsReferencedIdentifier = containsReferencedIdentifier;
exports.insertDeclarationBefore = insertDeclarationBefore;
exports.checkFalsePositiveReference = checkFalsePositiveReference;

var _types = require('./types');

var _types2 = _interopRequireDefault(_types);

var _placeAtLoc = require('ast-loc-utils/lib/placeAtLoc');

var _placeAtLoc2 = _interopRequireDefault(_placeAtLoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Get all identifiers in the given `VariableDeclaration` that would shadow
// identifiers defined in a higher scope.
function getShadowingIdentifiers(declarationPath) {
  if (!declarationPath.scope.parent) return [];

  return function () {
    var _arr = [];for (var _arr3 = declarationPath.node.declarations, _i2 = 0, _len3 = _arr3.length; _i2 < _len3; _i2++) {
      for (var _obj2 = declarationPath.get(`declarations.${_i2}`).getBindingIdentifiers(), _i3 = 0, _keys2 = Object.keys(_obj2), _len4 = _keys2.length; _i3 < _len4; _i3++) {
        var _k2 = _keys2[_i3];var _id = _obj2[_k2];
        if (declarationPath.scope.parent.hasBinding(_id.name)) _arr.push(_id);
      }
    }return _arr;
  }();
}

// Check if a path contains a reference to an identifier
function containsReferencedIdentifier(path, identifier) {
  var result = false;
  var identifierName = identifier.name;


  path.traverse({
    ReferencedIdentifier(refPath) {
      if (checkFalsePositiveReference(refPath)) {
        refPath.skip();
      } else if (refPath.node.name === identifierName) {
        result = true;
        refPath.stop();
      }
    } });

  return result;
} // Insert a prior declaration and register it as a binding with Babel
function insertDeclarationBefore(path, id, init, kind, loc) {
  path.insertBefore((0, _placeAtLoc2.default)(_types2.default.variableDeclaration(kind, [(0, _placeAtLoc2.default)(_types2.default.variableDeclarator(id, init), loc)]), loc));
  return path.scope.registerBinding(kind, path.getSibling(path.key - 1));
} // Workaround a babel bug with Flow types
function checkFalsePositiveReference(refPath) {
  var node = refPath.node;

  var parentNode = refPath.parentPath.node;
  if (!parentNode) return false;

  if (parentNode.type === "ObjectTypeProperty" && parentNode.key === node) {
    return !parentNode.computed;
  } else if (parentNode.type === "FunctionTypeParam") {
    return true;
  } else {
    return false;
  }
}